import { MsalProvider } from "@azure/msal-react";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App, ConfigurationNotice } from "./App";
import { application, settings } from "./auth";
import { browserError } from "./telemetry";
import "./styles.css";

const container = document.getElementById("root");
const config = settings();

if (container !== null) {
  const root = createRoot(container, { onUncaughtError: () => browserError("react") });
  if (config === null) {
    root.render(
      <StrictMode>
        <ConfigurationNotice />
      </StrictMode>,
    );
  } else {
    const msal = application(config);
    void msal
      .initialize()
      .then(() => msal.handleRedirectPromise())
      .then(() => {
        const account = msal.getAllAccounts()[0];
        if (account) msal.setActiveAccount(account);
        root.render(
          <StrictMode>
            <MsalProvider instance={msal}>
              <App config={config} />
            </MsalProvider>
          </StrictMode>,
        );
      });
  }
}
